import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, ArrowRight } from 'lucide-react';
import { contactData } from '../data/mock';
import { cities } from '../data/seoData';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contactData.whatsapp}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${contactData.phone}`;
  };

  const topCities = [cities.frankfurt, cities.wiesbaden, cities.mainz];
  
  const quickLinks = [
    { to: '/', label: 'Start' },
    { to: '/dienstleistungen', label: 'Dienstleistungen' },
    { to: '/uber-uns', label: 'Über uns' },
    { to: '/kontakt', label: 'Kontakt' },
    { to: '/faq', label: 'FAQ' }
  ];

  const legalLinks = [
    { to: '/impressum', label: 'Impressum' },
    { to: '/datenschutz', label: 'Datenschutz' },
    { 
      action: () => {
        localStorage.removeItem('cookieConsent');
        window.location.reload();
      },
      label: 'Cookie-Einstellungen'
    }
  ];

  return (
    <footer style={{
      background: 'linear-gradient(180deg, #0a0a0a 0%, #000000 100%)',
      borderTop: '1px solid rgba(8, 145, 178, 0.2)',
      marginTop: '120px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Subtle Glow Effect */}
      <div style={{
        position: 'absolute',
        top: '-50%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '800px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(8, 145, 178, 0.08) 0%, transparent 70%)',
        filter: 'blur(80px)',
        pointerEvents: 'none'
      }} />

      <div className="container mx-auto px-4" style={{ 
        maxWidth: '1400px', 
        position: 'relative', 
        zIndex: 2,
        paddingTop: '80px',
        paddingBottom: '64px'
      }}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_c62e1435-fe46-42e3-af21-45f9db06585d/artifacts/axk479ew_677c22b58e23f5af78d8ab92_Kein%20Titel%20%28170%20x%2095%20cm%29%20%28200%20x%2070%20cm%29-p-2000.png"
              alt="Crash Check Logo"
              style={{
                height: '45px',
                width: 'auto',
                objectFit: 'contain',
                marginBottom: '20px',
                filter: 'brightness(1.2)'
              }}
            />
            <p style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '16px',
              lineHeight: '1.6',
              marginBottom: '24px'
            }}>
              Unabhängige Kfz-Gutachten im Rhein-Main-Gebiet.
            </p>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {['Rechtssicher', 'Vor-Ort', 'Schnell'].map((chip, i) => (
                <div key={i} style={{
                  background: 'rgba(8, 145, 178, 0.15)',
                  border: '1px solid rgba(8, 145, 178, 0.3)',
                  padding: '6px 16px',
                  borderRadius: '20px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#06B6D4',
                  boxShadow: '0 0 20px rgba(8, 145, 178, 0.1)'
                }}>
                  {chip}
                </div>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 style={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: '700',
              marginBottom: '24px',
              letterSpacing: '0.5px'
            }}>
              Navigation
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {quickLinks.map((link, i) => (
                <Link
                  key={i}
                  to={link.to}
                  style={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    textDecoration: 'none',
                    fontSize: '15px',
                    fontWeight: '500',
                    transition: 'all 0.3s ease',
                    display: 'inline-block',
                    width: 'fit-content'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#06B6D4';
                    e.target.style.paddingLeft = '8px';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'rgba(255, 255, 255, 0.7)';
                    e.target.style.paddingLeft = '0';
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div style={{ 
              marginTop: '32px',
              paddingTop: '24px',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h4 style={{
                color: 'rgba(255, 255, 255, 0.5)',
                fontSize: '12px',
                fontWeight: '600',
                marginBottom: '12px',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                Einsatzgebiet
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                {topCities.map((city) => (
                  <Link
                    key={city.slug}
                    to={city.url}
                    style={{
                      color: 'rgba(255, 255, 255, 0.6)',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'color 0.3s ease',
                      display: 'inline-block',
                      width: 'fit-content'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#06B6D4'}
                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.6)'}
                  >
                    {city.name}
                  </Link>
                ))}
              </div>
              <Link
                to="/standorte"
                style={{
                  color: '#06B6D4',
                  fontSize: '14px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                Alle Standorte ansehen
                <ArrowRight size={14} />
              </Link>
            </div>
          </div>

          {/* Kontakt */}
          <div>
            <h3 style={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: '700',
              marginBottom: '24px',
              letterSpacing: '0.5px'
            }}>
              Kontakt
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
              <button
                onClick={handleWhatsApp}
                style={{
                  background: 'linear-gradient(135deg, rgba(8, 145, 178, 0.2) 0%, rgba(6, 182, 212, 0.15) 100%)',
                  border: '1px solid rgba(8, 145, 178, 0.3)',
                  color: '#06B6D4',
                  padding: '14px 24px',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  justifyContent: 'center',
                  boxShadow: '0 4px 20px rgba(8, 145, 178, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, rgba(8, 145, 178, 0.3) 0%, rgba(6, 182, 212, 0.2) 100%)';
                  e.currentTarget.style.boxShadow = '0 6px 32px rgba(8, 145, 178, 0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, rgba(8, 145, 178, 0.2) 0%, rgba(6, 182, 212, 0.15) 100%)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(8, 145, 178, 0.1)';
                }}
              >
                <MessageCircle size={18} />
                WhatsApp Soforthilfe
              </button>
              <button
                onClick={handleCall}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  color: 'rgba(255, 255, 255, 0.9)',
                  padding: '14px 24px',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
                }}
              >
                <Phone size={18} />
                Jetzt anrufen
              </button>
            </div>
            <div style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.5)', lineHeight: '1.8' }}>
              <p style={{ marginBottom: '8px' }}>
                <strong style={{ color: 'rgba(255, 255, 255, 0.7)' }}>E-Mail:</strong> {contactData.email}
              </p>
              <p>
                <strong style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Tel:</strong> {contactData.phone}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          marginTop: '60px',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          {/* Legal Links */}
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {legalLinks.map((link, i) => (
              link.action ? (
                <button
                  key={i}
                  onClick={link.action}
                  style={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.6)',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = 'rgba(8, 145, 178, 0.4)';
                    e.target.style.color = '#06B6D4';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  }}
                >
                  {link.label}
                </button>
              ) : (
                <Link
                  key={i}
                  to={link.to}
                  style={{
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    color: 'rgba(255, 255, 255, 0.6)',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '500',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    display: 'inline-block'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = 'rgba(8, 145, 178, 0.4)';
                    e.target.style.color = '#06B6D4';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.color = 'rgba(255, 255, 255, 0.6)';
                  }}
                >
                  {link.label}
                </Link>
              )
            ))}
          </div>

          {/* Credits */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.4)' }}>
              © {new Date().getFullYear()} {contactData.company}
            </span>
            <span style={{ 
              fontSize: '11px', 
              color: 'rgba(255, 255, 255, 0.25)',
              padding: '4px 12px',
              background: 'rgba(255, 255, 255, 0.03)',
              borderRadius: '6px',
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              Website by Zonik Solutions
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
